import React, { useState, useEffect } from 'react';
import axios from "axios";
import { Route, Routes, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import StaffList from './components/StaffList';
//import StaffDetails from './components/StaffDetails';
import StaffForm from './components/StaffForm';
import AttendanceList from './components/AttendanceList';
import HotEventList from './components/HotEventList';
import HotEventDetail from './components/HotEventDetail';
import HotEventHistory from "./components/HotEventHistory";
import LocationsPage from "./pages/setup/LocationsPage";
import BeaconPage from './pages/setup/BeaconPage';
import ExportT2HR from './pages/ExportT2HR';
import ApprovalCenter from './pages/ApprovalCenter';
import ManualRequestsReport from './pages/ManualRequestsReport';


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(null);


  useEffect(() => {
    const checkSession = async () => {
      try {
        const tenant = localStorage.getItem("tenant") || "";

        const res = await axios.get(`${process.env.REACT_APP_API_URL}/me`, {
          withCredentials: true,
          headers: { "X-Tenant": tenant }
        });

        if (res.data?.success && res.data?.user) {
          sessionStorage.setItem("session_valid", "yes");
          setIsLoggedIn(true);
          return;
        }
      } catch (err) {
        console.warn("Session check failed:", err?.response?.data || err);
      }

      // Force logout if token invalid
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("session_valid");
      setIsLoggedIn(false);
    };

    checkSession();
  }, []);

  if (isLoggedIn === null) {
    return <div>Loading...</div>; // Or any other loading indicator
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={!isLoggedIn ? <Login setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/" />}
      />
      <Route
        path="/"
        element={isLoggedIn ? <Dashboard setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />}
      />
      <Route
        path="/staff"
        element={isLoggedIn ? <StaffList setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />}
      />
      {/*<Route
          path="/staff/:id"
          element={isLoggedIn ? <StaffDetails setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />}
        /> */}
      <Route
        path="/staff/:id"
        element={isLoggedIn ? <StaffForm setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />}
      />
      <Route
        path="/staff/new"
        element={isLoggedIn ? <StaffForm setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />}
      />
      <Route
        path="/attendance"
        element={isLoggedIn ? <AttendanceList setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />}
      />
      <Route
        path="/emergency/hot"
        element={isLoggedIn ? <HotEventList setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />}
      />
      <Route
        path="/emergency/hot/:eventId"
        element={
          isLoggedIn
            ? <HotEventDetail setIsLoggedIn={setIsLoggedIn} />
            : <Navigate to="/login" />
        }
      />
      <Route
        path="/emergency/hot/history"
        element={isLoggedIn ? <HotEventHistory setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />}
      />
      <Route path="/setup/locations"
        element={isLoggedIn ? <LocationsPage setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />}
      />
      <Route path="/setup/beacons"
        element={isLoggedIn ? <BeaconPage setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />}
      />
      <Route
        path="/export/t2hr"
        element={isLoggedIn ? <ExportT2HR setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />}
      />
      <Route
        path="/approval/inbox"
        element={isLoggedIn ? <ApprovalCenter setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />}
      />
      <Route
        path="/reports/manual"
        element={isLoggedIn ? <ManualRequestsReport setIsLoggedIn={setIsLoggedIn} /> : <Navigate to="/login" />}
      />
    </Routes>
  );
}

export default App;